import React from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import CollapsableMenuItem from 'secured/components/layout/menu/CollapsableMenuItem';
import ActiveLink from 'secured/components/layout/menu/ActiveLink';

import { createRoute } from 'lib/util';

const Reports = ({ company, subcompany, isCollapsed, location, permissions, t, toggleMenu }) =>
  permissions['acl.reports.depreciation'] ||
  permissions['acl.reports.disabled'] ||
  permissions['acl.reports.employees_assets'] ||
  permissions['acl.reports.ins_outs'] ||
  permissions['acl.reports.historics'] ? (
    <CollapsableMenuItem
      label={t('menu.reports')}
      opened={!isCollapsed}
      icon={'line-chart'}
      handleToggle={(collapsed) => toggleMenu('reports', collapsed)}
    >
      <ul className="submenu-list">
        {permissions['acl.reports.depreciation'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={createRoute(company.id, subcompany.id, 'reports/depreciation')}
            >
              <i className="fa fa-area-chart fa-lg" />
              {t('menu.reports_depreciation')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.reports.disabled'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={createRoute(company.id, subcompany.id, 'reports/disabled')}
            >
              <i className="fa fa-table fa-lg" />
              {t('menu.reports_disabled')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.reports.employees_assets'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={createRoute(company.id, subcompany.id, 'reports/employees_assets')}
            >
              <i className="fa fa-file-archive-o fa-lg" />
              {t('menu.reports_employees_assets')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.reports.ins_outs'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={createRoute(company.id, subcompany.id, 'reports/ins_outs')}
            >
              <i className="fa fa-inbox fa-lg" />
              {t('menu.reports_ins_outs')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.reports.historics'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={createRoute(company.id, subcompany.id, 'reports/historics')}
            >
              <i className="fa fa-folder-open fa-lg" />
              {t('menu.reports_historics')}
            </ActiveLink>
          </li>
        )}
      </ul>
    </CollapsableMenuItem>
  ) : null;

export default withRouter(translate()(Reports));



// WEBPACK FOOTER //
// src/modules/secured/components/layout/menu/Reports.js